export enum RequestWorkflowActionCode {
	StudySubmittedByStudyOfficer = "STUDY_SUBMITTED_BY_STUDY_OFFICER",
	StudyReturnedToStudyOfficer = "STUDY_RETURNED_TO_STUDY_OFFICER",
	ApproveAndRaiseToDirector = "APPROVE_AND_RAISE_TO_DIRECTOR",
	ReturnToSupervisor = "RETURN_TO_SUPERVISOR",
	ApproveAndExecute = "APPROVE_AND_EXECUTE",
	ApproveAndRaiseToMinister = "APPROVE_AND_RAISE_TO_MINISTER",
	ApproveAction = "APPROVE_ACTION",
	ReturnToDirector = "RETURN_TO_DIRECTOR",
	CompletionResolved = "COMPLETION_RESOLVED",
	ProsecutionStatementSubmitted = "PROSECUTION_STATEMENT_SUBMITTED",
	ReturnToProsecutor = "RETURN_TO_PROSECUTOR",
	InvestigationReportSubmitted = "INVESTIGATION_REPORT_SUBMITTED",
	ReturnToInvestigator = "RETURN_TO_INVESTIGATOR",
	RequestSupplementaryInvestigation = "REQUEST_SUPPLEMENTARY_INVESTIGATION",
}
